/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAPOConfirmConfiguration.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Oct 10, 2019
*
* @Version      : Version 1.0
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 10, 2019
* Description  : Updated code as per ASDS-1471
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 17, 2019
* Description  : Updated code as per ASDS-1583
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Oct 05, 2020
 * Description   : ASDS - 3496 Bugfix UI Enhancements for Phase - II
 *
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import DisplayCustTypeCard from './DisplayCustTypeCard';
import CheckoutConstants from '../constants/checkout-constants';
import NonMSAPurchaseOrderConfigSummary from './NonMSAPurchaseOrderConfigSummary';
import TotalPriceCard from './TotalPriceCard';
import DisplayPurchaseTypeCard from './DisplayPurchaseTypeCard';

interface INonMSACustomerPO {
    productData: ICustomerPOData[];
    gotoCustomerCategoryTab: Function;
    gotoProductConfigureTab: Function;
    gotoProductPurchaseTab: Function;
    totalPrice: any;
    purchaseType: number;
}

interface ICustomerPOData {
    acOem: string;
    oemError: string;
    serialNumber: string;
    serialNumberError: string;
    purchaseOrderNumber: string;
    purchaseOrderNumberError: string;
    expiryDate: string;
    unitPrice: number;
    subProductId: string;
}

function NonMSAPOConfirmConfiguration(props: INonMSACustomerPO) {
    return(
        <div className="confirmation-step-card">
            <DisplayCustTypeCard gotoCustomerCategoryTab={props.gotoCustomerCategoryTab} customerType={CheckoutConstants.CUSTOMER_CATEGORY_NONMSA}/>
            <DisplayPurchaseTypeCard gotoProductPurchaseTab={props.gotoProductPurchaseTab} purchaseTypeSubText={CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO} />
            <NonMSAPurchaseOrderConfigSummary productData={props.productData} gotoProductConfigureTab={props.gotoProductConfigureTab} />
            <TotalPriceCard totalPrice={props.totalPrice} />
        </div>
    );
}

const mapDispatchToProps = {
    gotoCustomerCategoryTab: ConfigureAPUActions.gotoCustomerCategoryTab,
    gotoProductConfigureTab: ConfigureAPUActions.gotoNonMsaProductConfigureTab,
    gotoProductPurchaseTab: ConfigureAPUActions.gotoProductConfigureTab,
};

function mapStateToProps(state) {
    return {
        totalPrice: state.configAPUData.payload.totalPrice,
        purchaseType: state.configAPUData.payload.purchaseType,
        productData: state.configAPUData.payload.nonMsaConfigData,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSAPOConfirmConfiguration);